export const PARENT_CONTAINER_HEIGHT = "4.5rem";
export const PARENT_CONTAINER_PADDING = "1.7rem";

export const WHITE_BOX_HEIGHT = "11.11rem";
export const TABLE_HEIGHT = "22.1rem";
export const TABLE_HEIGHT_NO_PAGINATION = "16.1rem";
export const TABLE_HEIGHT_NO_SEARCH_FILTER = "16.8rem";
export const TABLE_HEIGHT_NO_BACKGROUND_TABS = "24rem";
export const TABLE_HEIGHT_NO_PAGINATION_NO_FILTER = "12.1rem";
export const TABLE_HEIGHT_NO_DATA_FOUND_NO_FILTER = "14.3rem";
export const TABLE_HEIGHT_NO_DATA_FOUND_SEARCH_FILTER = "18.3rem";
